/* eslint-disable lodash/prefer-lodash-typecheck */ // eslint-disable-next-line max-classes-per-file
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import { sumReceiptDiscountsInCents } from '@dutchie/common/utils/receipt-summary';
import { getGlobalSpecialsSettings } from './utilities';
var BigRoundEnums = {
    ROUND_DOWN: 0,
    ROUND_HALF_UP: 1,
    ROUND_HALF_EVEN: 2,
    ROUND_UP: 3
};
var DetailBase = /*#__PURE__*/ function() {
    "use strict";
    function DetailBase() {
        _class_call_check(this, DetailBase);
        this.remainder = Big(0);
    }
    _create_class(DetailBase, [
        {
            key: "addDataValue",
            value: function addDataValue() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, type = _ref.type, subtype = _ref.subtype, value = _ref.value, _ref_doNotRound = _ref.doNotRound, doNotRound = _ref_doNotRound === void 0 ? false : _ref_doNotRound;
                // this will round decimals to the nearest cent
                //
                // Might need to deal with remainders across the subtype of sales tax
                // that are vape taxes and the rest of sales taxes.
                var intValue = doNotRound ? value : value.round(0, BigRoundEnums.ROUND_HALF_UP);
                this[type] = this[type] || {};
                this[type][subtype] = (this[type][subtype] || Big(0)).plus(intValue);
                var remainder = value.minus(intValue);
                this[type].remainder = (this[type].remainder || Big(0)).add(remainder);
            }
        },
        {
            key: "addDataArray",
            value: function addDataArray() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, type = _ref.type, subtype = _ref.subtype, value = _ref.value, id = _ref.id, name = _ref.name, additionalAttributes = _ref.additionalAttributes;
                // this will round decimals to the nearest cent
                var intValue = value.round(0, BigRoundEnums.ROUND_HALF_UP);
                this[type] = this[type] || {};
                this[type][subtype] = this[type][subtype] || [];
                this[type][subtype].push(_object_spread({
                    id: id,
                    name: name,
                    value: intValue
                }, additionalAttributes));
                var remainder = value.minus(intValue);
                // We actually always want to add the remainder here, whether negative or positive.
                this[type].remainder = (this[type].remainder || Big(0)).add(remainder);
            }
        },
        {
            key: "addTax",
            value: function addTax(param) {
                var type = param.type, value = param.value;
                if (!value.eq(0)) {
                    this.addDataValue({
                        type: 'taxes',
                        subtype: type,
                        value: value
                    });
                }
            }
        },
        {
            key: "addFee",
            value: function addFee(param) {
                var type = param.type, value = param.value;
                if (!value.eq(0)) {
                    this.addDataValue({
                        type: 'fees',
                        subtype: type,
                        value: value
                    });
                }
            }
        },
        {
            key: "addReward",
            value: function addReward(param) {
                var type = param.type, value = param.value, id = param.id, name = param.name;
                if (!value.eq(0)) {
                    this.addDataArray({
                        type: 'rewards',
                        subtype: type,
                        value: value,
                        id: id,
                        name: name
                    });
                }
            }
        },
        {
            key: "addDiscount",
            value: function addDiscount(param) {
                var _param_type = param.type, type = _param_type === void 0 ? 'all' : _param_type, value = param.value, id = param.id, name = param.name, _param_additionalAttributes = param.additionalAttributes, additionalAttributes = _param_additionalAttributes === void 0 ? {} : _param_additionalAttributes;
                if (!value.eq(0)) {
                    this.addDataArray({
                        type: 'discounts',
                        subtype: type,
                        value: value,
                        id: id,
                        name: name,
                        additionalAttributes: additionalAttributes
                    });
                }
            }
        },
        {
            key: "addIncentive",
            value: function addIncentive(param) {
                var _param_type = param.type, type = _param_type === void 0 ? 'payment' : _param_type, value = param.value, id = param.id, name = param.name, _param_additionalAttributes = param.additionalAttributes, additionalAttributes = _param_additionalAttributes === void 0 ? {} : _param_additionalAttributes;
                if (!value.eq(0)) {
                    this.addDataArray({
                        type: 'incentives',
                        subtype: type,
                        value: value,
                        id: id,
                        name: name,
                        additionalAttributes: additionalAttributes
                    });
                }
            }
        },
        {
            key: "addMixAndMatch",
            value: function addMixAndMatch(param) {
                var type = param.type, value = param.value;
                if (!value.eq(0)) {
                    this.addDataValue({
                        type: 'mixAndMatch',
                        subtype: type,
                        value: value
                    });
                }
            }
        },
        {
            key: "addRounding",
            value: function addRounding(param) {
                var type = param.type, value = param.value;
                if (!value.eq(0)) {
                    this.addDataValue({
                        type: 'rounding',
                        subtype: type,
                        value: value,
                        doNotRound: true
                    });
                }
            }
        },
        {
            key: "addRoundupForCharity",
            value: function addRoundupForCharity(param) {
                var type = param.type, value = param.value;
                if (!value.eq(0)) {
                    this.addDataValue({
                        type: 'roundupForCharity',
                        subtype: type,
                        value: value,
                        doNotRound: true
                    });
                }
            }
        }
    ]);
    return DetailBase;
}();
// Export this for unit tests.  It should only be used from Receipt otherwise.
export var ReceiptDetails = /*#__PURE__*/ function(DetailBase1) {
    "use strict";
    _inherits(ReceiptDetails, DetailBase1);
    function ReceiptDetails() {
        _class_call_check(this, ReceiptDetails);
        var _this;
        _this = _call_super(this, ReceiptDetails);
        _this.details = {
            order: {},
            products: []
        };
        return _this;
    }
    _create_class(ReceiptDetails, [
        {
            key: "addProduct",
            value: function addProduct(productID, quantity, basePrice, option) {
                var menuPrice = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, summaryPrice = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, cartPrice = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, checkoutPrice = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, specialCartPrice = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null, specialCheckoutPrice = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null;
                // DetailBase is acting like "ProductDetail" here.
                var newProduct = new DetailBase();
                newProduct.id = productID;
                newProduct.quantity = quantity;
                newProduct.basePrice = basePrice;
                newProduct.option = option;
                newProduct.menuPrice = menuPrice !== null && menuPrice !== void 0 ? menuPrice : basePrice.times(quantity).round(0, BigRoundEnums.ROUND_HALF_UP);
                newProduct.summaryPrice = summaryPrice !== null && summaryPrice !== void 0 ? summaryPrice : basePrice.times(quantity).round(0, BigRoundEnums.ROUND_HALF_UP);
                // Left null (not defaulted to basePrice*quantity like menuPrice/summaryPrice) when absent, so the
                // consumer can tell "field missing" apart from "price is genuinely 0" and fall back correctly.
                newProduct.cartPrice = cartPrice;
                newProduct.checkoutPrice = checkoutPrice;
                newProduct.specialCartPrice = specialCartPrice;
                newProduct.specialCheckoutPrice = specialCheckoutPrice;
                newProduct.total = basePrice.times(quantity).round(0, BigRoundEnums.ROUND_HALF_UP);
                this.details.products.push(newProduct);
                return newProduct;
            }
        }
    ]);
    return ReceiptDetails;
}(DetailBase);
/* New structure to hold all of the information about the order.  All values are in cents.
 * Ultimately all of the other values returned from this function will be deprecated and removed.
 *
 * For each of taxes, fees, rewards, and discounts there are a series of attributers that provide
 * a breakdown and a total attribute that is the sum of those.
 *
 * We include the taxConfig that this was developed under because tax configs change and we don't
 * have these versioned.
 */ export var Receipt = /*#__PURE__*/ function(ReceiptDetails) {
    "use strict";
    _inherits(Receipt, ReceiptDetails);
    function Receipt(dispensary) {
        _class_call_check(this, Receipt);
        var _this;
        _this = _call_super(this, Receipt);
        _this.summary = {
            subtotal: 0,
            taxes: 0,
            fees: 0,
            rewards: 0,
            discounts: 0,
            incentives: 0,
            mixAndMatch: 0,
            total: 0,
            rounding: 0,
            roundupForCharity: 0
        };
        _this.specialsSettings = getGlobalSpecialsSettings(dispensary);
        _this.taxConfig = dispensary.taxConfig;
        return _this;
    }
    _create_class(Receipt, [
        {
            /**
   * Total value this receipt takes off the order, in cents -- discounts (coupons included),
   * mix and match, rewards, and incentives. Exposed so analytics and display code agree on
   * what "the discount" means instead of each re-deriving the sum.
   */ key: "totalDiscounts",
            value: function totalDiscounts() {
                return sumReceiptDiscountsInCents(this.summary);
            }
        },
        {
            key: "finalize",
            value: function finalize() {
                var totalTaxes = Big(0);
                var totalFees = Big(0);
                var totalRewards = Big(0);
                var totalDiscounts = Big(0);
                var totalIncentives = Big(0);
                var totalMixAndMatch = Big(0);
                var totalRounding = Big(0);
                var totalRoundupForCharity = Big(0);
                var taxBreakdown = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator = this.details.products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var product = _step.value;
                        var _product_mixAndMatch;
                        product.taxes = product.taxes || {};
                        product.taxes.total = Receipt.sumSection(product.taxes);
                        totalTaxes = totalTaxes.plus(product.taxes.total).plus(product.taxes.remainder || 0).round(0, BigRoundEnums.ROUND_HALF_UP);
                        Receipt.accumulateTaxes(taxBreakdown, product.taxes);
                        product.rewards = product.rewards || {};
                        product.rewards.total = Receipt.sumValueSection(product.rewards);
                        totalRewards = totalRewards.plus(product.rewards.total).plus(product.rewards.remainder || 0).round(0, BigRoundEnums.ROUND_HALF_UP);
                        product.discounts = product.discounts || {};
                        product.discounts.total = Receipt.sumValueSection(product.discounts).plus(product.discounts.remainder || Big(0));
                        // Before, we were rounding product.discount.total before adding it to the totalDiscounts.
                        // This resulted in extra pennies on totalDiscounts.
                        // Now, we will add the unrounded product.discount.total to totalDiscounts
                        // and THEN round totalDiscounts after we have iterated through the products and have our raw total
                        totalDiscounts = totalDiscounts.plus(product.discounts.total);
                        product.discounts.total = product.discounts.total.round(0, BigRoundEnums.ROUND_HALF_UP);
                        product.incentives = product.incentives || {};
                        product.incentives.total = Receipt.sumValueSection(product.incentives).plus(product.incentives.remainder || Big(0));
                        // Accumulate incentives using unrounded totals across products, then round once after iteration
                        totalIncentives = totalIncentives.plus(product.incentives.total);
                        product.incentives.total = product.incentives.total.round(0, BigRoundEnums.ROUND_HALF_UP);
                        product.mixAndMatch = product.mixAndMatch || {};
                        // because mix and match isn't following the same pattern
                        // as the other line items (yet) we need to be a bit more
                        // careful here checking for null or non Big()s
                        totalMixAndMatch = totalMixAndMatch.plus(((_product_mixAndMatch = product.mixAndMatch) === null || _product_mixAndMatch === void 0 ? void 0 : _product_mixAndMatch.total) || 0).round(0, BigRoundEnums.ROUND_HALF_UP);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                totalTaxes = totalTaxes.plus(Receipt.sumSection(this.taxes));
                totalFees = Receipt.sumSection(this.fees);
                totalRewards = totalRewards.plus(Receipt.sumValueSection(this.rewards));
                totalDiscounts = totalDiscounts.round(0, BigRoundEnums.ROUND_HALF_UP).plus(Receipt.sumValueSection(this.discounts));
                totalIncentives = totalIncentives.round(0, BigRoundEnums.ROUND_HALF_UP).plus(Receipt.sumValueSection(this.incentives));
                totalRounding = Receipt.sumSection(this.rounding);
                totalRoundupForCharity = Receipt.sumSection(this.roundupForCharity);
                // Calculate total products before tax adjustments
                var totalProducts = _.reduce(_.map(this.details.products, function(product) {
                    return product.basePrice.times(product.quantity).plus(product.remainder).round(0, BigRoundEnums.ROUND_HALF_UP);
                }), function(total, value) {
                    return total.plus(value);
                }, Big(0));
                // this ensures the taxes in both the product and the order level are on the taxBreakdown,
                // this specifically happens with feeTaxes in CA where the tax is placed on the Receipt instead of the receiptDetail
                this.details.taxBreakdown = _.mergeWith({}, taxBreakdown, this.taxes, function(objValue, srcValue) {
                    if (objValue && srcValue) {
                        return objValue.plus(srcValue);
                    }
                    return undefined;
                });
                // Calculate final total by adding all components
                // Note: taxes (totalTaxes) are added here, which includes the taxes we subtracted above
                this.summary.total = totalProducts.plus(totalTaxes).plus(totalFees).minus(totalRewards).minus(totalDiscounts).minus(totalIncentives).plus(totalRounding).plus(totalRoundupForCharity);
                this.summary.subtotal = totalProducts;
                this.summary.taxes = totalTaxes;
                this.summary.fees = totalFees;
                this.summary.rewards = totalRewards;
                this.summary.discounts = totalDiscounts;
                this.summary.incentives = totalIncentives;
                this.summary.mixAndMatch = totalMixAndMatch;
                this.summary.rounding = totalRounding;
                this.summary.roundupForCharity = totalRoundupForCharity;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var rv = _.mapValues({
                    specialsSettings: this.specialsSettings,
                    taxConfig: this.taxConfig,
                    summary: this.summary,
                    details: {
                        order: this.details.order,
                        products: this.details.products,
                        taxBreakdown: this.details.taxBreakdown
                    }
                }, Receipt.toJSONMapper);
                if (!_.isNil(this.taxes)) {
                    rv.details.order.taxes = _.mapValues(this.taxes, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.fees)) {
                    rv.details.order.fees = _.mapValues(this.fees, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.rewards)) {
                    rv.details.order.rewards = _.mapValues(this.rewards, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.discounts)) {
                    rv.details.order.discounts = _.mapValues(this.discounts, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.incentives)) {
                    rv.details.order.incentives = _.mapValues(this.incentives, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.mixAndMatch)) {
                    rv.details.order.mixAndMatch = _.mapValues(this.mixAndMatch, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.rounding)) {
                    rv.details.order.rounding = _.mapValues(this.rounding, Receipt.toJSONMapper);
                }
                if (!_.isNil(this.roundupForCharity)) {
                    rv.details.order.roundupForCharity = _.mapValues(this.roundupForCharity, Receipt.toJSONMapper);
                }
                return rv;
            }
        }
    ], [
        {
            key: "sumSection",
            value: function sumSection(section) {
                return _.reduce(section, function(total, value, key) {
                    return total.plus(_.includes(Receipt.specialKeys, key) ? Big(0) : value);
                }, Big(0));
            }
        },
        {
            key: "sumValueSection",
            value: function sumValueSection(section) {
                return _.reduce(section, function(total, value, key) {
                    try {
                        return total.plus(_.includes(Receipt.specialKeys, key) ? Big(0) : _.reduce(value, function(tot, val) {
                            return tot.plus(val.value);
                        }, Big(0)));
                    } catch (e) {
                        console.log(e);
                        throw e;
                    }
                }, Big(0));
            }
        },
        {
            key: "accumulateTaxes",
            value: function accumulateTaxes(breakdown, section) {
                _.forEach(section, function(value, key) {
                    if (!_.includes(Receipt.specialKeys, key)) {
                        breakdown[key] = breakdown[key] || Big(0);
                        breakdown[key] = breakdown[key].plus(value);
                    }
                });
            }
        },
        {
            key: "toJSONMapper",
            value: function toJSONMapper(value) {
                var _value_constructor;
                // Check for Big.js objects (including corrupted ones from test environments)
                var isBigLike = _instanceof(value, Big) || (value === null || value === void 0 ? void 0 : (_value_constructor = value.constructor) === null || _value_constructor === void 0 ? void 0 : _value_constructor.name) === 'Big' && typeof value.s === 'number' && typeof value.e === 'number' && Array.isArray(value.c);
                if (isBigLike) {
                    var _value_c;
                    // Handle corrupted Big.js objects (when coefficient array contains objects instead of numbers)
                    if (!_instanceof(value, Big) && ((_value_c = value.c) === null || _value_c === void 0 ? void 0 : _value_c.some(function(coef) {
                        return (typeof coef === "undefined" ? "undefined" : _type_of(coef)) === 'object';
                    }))) {
                        return 0; // Safe fallback for corrupted objects
                    }
                    return Number(value);
                }
                if (_.isArray(value)) {
                    return _.map(value, function(val) {
                        return _.mapValues(val, Receipt.toJSONMapper);
                    });
                }
                if (!_.isFunction(value) && Object(value) === value) {
                    return _.mapValues(value, Receipt.toJSONMapper);
                }
                return value;
            }
        }
    ]);
    return Receipt;
}(ReceiptDetails);
_define_property(Receipt, "specialKeys", [
    'total',
    'remainder'
]);
